
















































































import { Component, Vue } from 'vue-property-decorator';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import FooterButton from '@/components/FooterButton.vue';
import OrgErrorMessage from '@/components/OrgErrorMessage.vue';
import { CameraChildErrorCode } from '@/resources/error/CameraChildErrorCode';
import { ShootType } from '@/store/modules/camera';
import IdDocType from '@/resources/enum/IdDocType';

type AutomaticCode1 = 'frame' | 'size' | 'sharpness' | 'highlight' | 'brightness';
type AutomaticCode2 = 'confidence' | 'diagonal' | 'is_grayscale' | 'similarity' | 'face' | 'straight' | 'face_quality';
type AutomaticCode3 =
  | 'i_close'
  | 'i_cropped'
  | 'i_close_to_border'
  | 'i_small'
  | 'i_eyes_closed'
  | 'i_occluded'
  | 'i_many_faces'
  | 'i_angle_too_large'
  | 'i_low_quality'
  | 'i_undefined';
type ErrorCode = CameraChildErrorCode | AutomaticCode1 | AutomaticCode2 | AutomaticCode3;

@Component({
  components: {
    CameraPageHeader,
    FooterButton,
    OrgErrorMessage
  }
})
export default class Page extends Vue {
  public messages1: string[] = [];
  public dotList: string[][] = [];
  public checkList: { text: string; checked: boolean }[] = [];
  public messages2: string[] = [];
  private photoAspectRatio: number = -1;
  private scrollerOuterHeight: number = 0;
  private scrollerInnerHeight: number = 0;
  private dynamicAreaHeight: number = 0;
  private pageFooterHeight: number = 0;
  public isAutodetectOver: boolean = false;
  private isManyRetry: boolean = false;

  private get pageTitle(): string {
    if (this.isGpDocPage) {
      const page: number = this.$store.getters['camera/gpdocPageCurr'];
      return this.$t(this.$store.state.camera.i18nKeyErrorTitleString, { page }) as string;
    } else if (this.isOpDocPage) {
      const term: number = this.$store.getters['camera/opdocTermCurr'];
      return this.$t(this.$store.state.camera.i18nKeyErrorTitleString, { term }) as string;
    } else {
      return this.$t(this.$store.state.camera.i18nKeyErrorTitleString) as string;
    }
  }

  private get isIdDocFront(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-front';
  }

  private get isIdDocDiagonal(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-diagonal';
  }

  private get isIdDocBack(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-back';
  }

  private get isGpDocPage(): boolean {
    return this.$store.getters['camera/isGpdoc'];
  }

  private get isOpDocPage(): boolean {
    return this.$store.getters['camera/isOpdoc'];
  }

  private get isFaceFront(): boolean {
    return this.$store.state.camera.shootType === 'face-front';
  }

  private get isFaceAction(): boolean {
    return this.$store.state.camera.shootType === 'face-action';
  }

  private get isIdDocMyNumberCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTi) return true;
    return false;
  }

  private get isIdDocResidenceCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardTi) return true;
    return false;
  }

  private get isIdDocSpecialPermanentResidentCertificate(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateTi) return true;
    return false;
  }

  private get isIdDocPassport(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.PassportHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTi) return true;
    return false;
  }

  private get trimmedPhoto(): string {
    return '';
  }

  public get photoHeight(): number {
    if (this.photoAspectRatio < 0) return 0;
    const displayWidth: number = this.$store.state.camera.displayWidth;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    if (displayWidth <= 0 || displayHeight <= 0) return 0;
    // 画面高さから取りうる画像高さ
    const pageHeaderHeight: number = this.$store.state.camera.headerHeight;
    const popupMarginHeight: number = 20;
    const popupHeaderHeight: number = 40;
    const imageMarginHeight: number = 20;
    const popupFooterMarginHeight: number = 30;
    let totalHeight: number = this.dynamicAreaHeight;
    totalHeight += pageHeaderHeight + popupMarginHeight + popupMarginHeight + this.pageFooterHeight;
    totalHeight += popupHeaderHeight + imageMarginHeight + imageMarginHeight + popupFooterMarginHeight;
    const maxPhotoHeight: number = displayHeight - totalHeight;
    // 画面幅から計算する画像高さ
    const popupMarginWidth: number = 20;
    const imageMarginWidth: number = 60;
    const photoMarginHorizontal: number = popupMarginWidth + imageMarginWidth;
    const basePhotoHeight: number = (displayWidth - photoMarginHorizontal * 2) / this.photoAspectRatio;
    // 画像高さを計算する
    const photoHeight: number = Math.min(basePhotoHeight, maxPhotoHeight);
    const minPhotoHeight: number = 100;
    return Math.max(photoHeight, minPhotoHeight);
  }

  private get isScroll(): boolean {
    return this.scrollerInnerHeight > this.scrollerOuterHeight;
  }

  // クエリからエラー情報を配列で取得
  private get errorFields(): ErrorCode[] {
    const queryFields: string | (string | null)[] | undefined = this.$route.query.fields;
    const isString: boolean = typeof queryFields === 'string';
    return (isString ? [queryFields as ErrorCode] : (queryFields as ErrorCode[])) || [];
  }

  public async created(): Promise<void> {
    // ページマウント時の設定
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }

  public async mounted(): Promise<void> {
    const shootType: ShootType = this.$store.state.camera.shootType;
    const isPC: boolean = this.$store.getters['camera/isPC'];

    if (this.errorFields.indexOf(CameraChildErrorCode.ShootTimeout) >= 0) {
      // 手動撮影タイムアウトエラー
      const key1: string = 'cameraCameraChildError.messages.ShootTimeout';
      this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
      this.dotList = [];
      this.checkList = [];
      this.messages2 = [];
      this.isManyRetry = false;
    } else if (this.errorFields.indexOf(CameraChildErrorCode.AutodetectTimeout) >= 0) {
      // 自動撮影タイムアウトエラー
      const key1: string = 'cameraCameraChildError.messages.AutodetectTimeout';
      this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
      this.dotList = [];
      this.checkList = [];
      this.messages2 = [];
      this.isManyRetry = false;
      this.isAutodetectOver = true;
    } else if (this.errorFields.indexOf(CameraChildErrorCode.Automatic) >= 0) {
      // 撮影結果の自動判定エラー処理
      if (this.errorFields.indexOf(CameraChildErrorCode.ManyRetry) >= 0) {
        const keySection: string = this.isFaceFront ? 'face' : 'idDoc';
        const key1: string = `cameraCameraChildError.messages.manyRetry.${keySection}.messages1`;
        const key2: string = `cameraCameraChildError.messages.manyRetry.${keySection}.dotList`;
        const orgName: string = this.$store.getters['auth/currentLanguageOrgName'];
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = true;
      } else if (this.errorFields.indexOf('is_grayscale') >= 0) {
        // 白黒撮影エラー
        const key1: string = 'cameraCameraChildError.messages.is_grayscale';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('confidence') >= 0) {
        // 信頼性エラー
        const key1: string = 'cameraCameraChildError.messages.confidence.messages1';
        const key2: string = 'cameraCameraChildError.messages.confidence.dotList';
        const key3: string = 'cameraCameraChildError.messages.confidence.messages2';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('diagonal') >= 0) {
        // 斜め撮影エラー
        const key1: string = 'cameraCameraChildError.messages.diagonal.messages1';
        const key2: string = 'cameraCameraChildError.messages.diagonal.dotList';
        const key3: string = 'cameraCameraChildError.messages.diagonal.messages2';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('face_quality') >= 0) {
        const key1: string = 'cameraCameraChildError.messages.face_quality';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.isFaceFront && this.errorFields.indexOf('frame') >= 0) {
        // 顔正面撮影の枠内判定
        const key1: string = 'cameraCameraChildError.messages.straight.messages1';
        const key2: string = 'cameraCameraChildError.messages.straight.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.isFaceFront && this.errorFields.indexOf('straight') >= 0) {
        // 顔正面撮影の正面判定
        const key1: string = 'cameraCameraChildError.messages.straight.messages1';
        const key2: string = 'cameraCameraChildError.messages.straight.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (
        this.errorFields.indexOf('frame') >= 0 ||
        this.errorFields.indexOf('size') >= 0 ||
        this.errorFields.indexOf('sharpness') >= 0 ||
        this.errorFields.indexOf('highlight') >= 0 ||
        this.errorFields.indexOf('brightness') >= 0
      ) {
        // 色々な撮影エラー
        const key1: string = 'cameraCameraChildError.messages.Automatic.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.messages2 = [];
        this.isManyRetry = false;
        this.checkList = ((): AutomaticCode1[] => {
          if (shootType === 'identity-document-front') return ['frame', 'size', 'sharpness', 'highlight', 'brightness'];
          if (shootType === 'identity-document-back') return ['frame', 'size', 'brightness'];
          if (shootType === 'face-front') return ['sharpness', 'brightness', 'highlight'];
          return [];
        })().map((code: AutomaticCode1): {
          text: string;
          checked: boolean;
        } => ({
          text: this.$t(`cameraCameraChildError.messages.Automatic.${shootType}.${code}`) as string,
          checked: this.errorFields.some((field: ErrorCode): boolean => field === code)
        }));
      } else if (this.errorFields.indexOf('similarity') >= 0) {
        // 写真同一性エラー
        const isPassportDiagonal = this.isIdDocPassport && this.isIdDocDiagonal;
        const partSection = isPassportDiagonal ? `passport.${shootType}` : 'other';
        const key1: string = `cameraCameraChildError.messages.similarity.${partSection}`;
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('face') >= 0) {
        // 顔認識エラー
        const key1: string = 'cameraCameraChildError.messages.face.messages';
        const key2: string = 'cameraCameraChildError.messages.face.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_close') >= 0) {
        // 顔がカメラに近すぎる
        const key1: string = 'cameraCameraChildError.messages.i_close.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_cropped') >= 0) {
        // 顔がずれている
        const key1: string = 'cameraCameraChildError.messages.i_cropped.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_close_to_border') >= 0) {
        // 顔がずれている
        const key1: string = 'cameraCameraChildError.messages.i_close_to_border.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_small') >= 0) {
        // 顔が小さすぎる
        const key1: string = 'cameraCameraChildError.messages.i_small.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_eyes_closed') >= 0) {
        // 目を閉じている
        const key1: string = 'cameraCameraChildError.messages.i_eyes_closed.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_occluded') >= 0) {
        // 顔が検出できない
        const key1: string = 'cameraCameraChildError.messages.i_occluded.messages';
        const key2: string = 'cameraCameraChildError.messages.i_occluded.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_many_faces') >= 0) {
        // 検出された顔が多すぎる
        const key1: string = 'cameraCameraChildError.messages.i_many_faces.messages';
        const key2: string = 'cameraCameraChildError.messages.i_many_faces.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_angle_too_large') >= 0) {
        // 顔が正面を向いていない
        const key1: string = 'cameraCameraChildError.messages.i_angle_too_large.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_low_quality') >= 0) {
        // qualityが閾値を下回った場合
        const key1: string = 'cameraCameraChildError.messages.i_low_quality.messages';
        const key2: string = 'cameraCameraChildError.messages.i_low_quality.dotList';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else if (this.errorFields.indexOf('i_undefined') >= 0) {
        // その他システムエラー
        const key1: string = 'cameraCameraChildError.messages.i_undefined.messages';
        this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
        this.dotList = [];
        this.checkList = [];
        this.messages2 = [];
        this.isManyRetry = false;
      } else {
        // サーバから受け取ったfieldsが空っぽ！！
        if (
          (this.isIdDocResidenceCard || this.isIdDocSpecialPermanentResidentCertificate) &&
          (this.isIdDocFront || this.isIdDocBack)
        ) {
          // 在留カード・特別永住者証明書の表面と裏面の場合は信頼性エラー
          const key1: string = 'cameraCameraChildError.messages.confidence.messages1';
          const key2: string = 'cameraCameraChildError.messages.confidence.dotList';
          const key3: string = 'cameraCameraChildError.messages.confidence.messages2';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
          this.checkList = [];
          this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
          this.isManyRetry = false;
        } else if (
          (this.isIdDocResidenceCard || this.isIdDocSpecialPermanentResidentCertificate) &&
          this.isIdDocDiagonal
        ) {
          // 在留カード・特別永住者証明書の斜面の場合は斜め撮影エラー
          const key1: string = 'cameraCameraChildError.messages.diagonal.messages1';
          const key2: string = 'cameraCameraChildError.messages.diagonal.dotList';
          const key3: string = 'cameraCameraChildError.messages.diagonal.messages2';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
          this.checkList = [];
          this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
          this.isManyRetry = false;
        } else if (isPC && this.isIdDocMyNumberCard && (this.isIdDocFront || this.isIdDocBack)) {
          // PCのマイナンバーカードの表面と裏面の場合は信頼性エラー
          const key1: string = 'cameraCameraChildError.messages.confidence.messages1';
          const key2: string = 'cameraCameraChildError.messages.confidence.dotList';
          const key3: string = 'cameraCameraChildError.messages.confidence.messages2';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
          this.checkList = [];
          this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
          this.isManyRetry = false;
        } else if (isPC && this.isIdDocMyNumberCard && this.isIdDocDiagonal) {
          // PCのマイナンバーカードの斜面の場合は斜め撮影エラー
          const key1: string = 'cameraCameraChildError.messages.diagonal.messages1';
          const key2: string = 'cameraCameraChildError.messages.diagonal.dotList';
          const key3: string = 'cameraCameraChildError.messages.diagonal.messages2';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
          this.checkList = [];
          this.messages2 = (this.$t(key3) as { [key: number]: string }) as string[];
          this.isManyRetry = false;
        } else if (this.isIdDocFront || this.isIdDocBack) {
          // 表面と裏面の認識失敗エラー
          const key1: string = 'cameraCameraChildError.messages.identity-document-front-back';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = [];
          this.checkList = [];
          this.messages2 = [];
          this.isManyRetry = false;
        } else if (this.isIdDocDiagonal) {
          // 斜面の認識失敗エラー
          const key1: string = 'cameraCameraChildError.messages.identity-document-diagonal';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = [];
          this.checkList = [];
          this.messages2 = [];
          this.isManyRetry = false;
        } else if (this.isFaceFront) {
          // 顔正面の認識失敗エラー
          const key1: string = 'cameraCameraChildError.messages.face-front.messages';
          const key2: string = 'cameraCameraChildError.messages.face-front.dotList';
          this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
          this.dotList = (this.$t(key2) as { [key: number]: { [key: number]: string } }) as string[][];
          this.checkList = [];
          this.messages2 = [];
          this.isManyRetry = false;
        }
      }
    } else {
      // その他不明なエラー
      const key1: string = 'cameraCameraChildError.messages.others';
      this.messages1 = (this.$t(key1) as { [key: number]: string }) as string[];
      this.dotList = [];
      this.checkList = [];
      this.messages2 = [];
      this.isManyRetry = false;
    }

    if (this.trimmedPhoto) {
      // 画像のアスペクト比を計測
      await new Promise((resolve: (image: HTMLImageElement) => void): void => {
        const image: HTMLImageElement = new Image();
        image.addEventListener('load', () => resolve(image));
        image.src = this.trimmedPhoto;
      }).then((image: HTMLImageElement): void => {
        this.photoAspectRatio = image.naturalWidth / image.naturalHeight;
      });
    }

    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const txtList: HTMLDivElement = this.$el.getElementsByClassName('error-popup-text').item(0) as HTMLDivElement;
    const pageFooter: HTMLDivElement = this.$el.getElementsByClassName('page-footer').item(0) as HTMLDivElement;
    const scrollerOuterRect: DOMRect = (scroller.parentNode as HTMLDivElement).getBoundingClientRect() as DOMRect;
    const scrollerInnerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    const txtListRect: DOMRect = txtList.getBoundingClientRect() as DOMRect;
    const pageFooterRect: DOMRect = pageFooter.getBoundingClientRect() as DOMRect;
    this.scrollerOuterHeight = scrollerOuterRect.height;
    this.scrollerInnerHeight = scrollerInnerRect.height;
    this.dynamicAreaHeight = txtListRect.height;
    this.pageFooterHeight = pageFooterRect.height;
  }

  public onRestart(): void {
    if (this.isAutodetectOver) this.$store.commit('camera/isDetectStop', true);
    this.$router.push(this.$store.getters['camera/locationIntroduction']);
  }
}
